$(document).ready(function() {
    let hasFlash = false;

    try {
        hasFlash = Boolean(new ActiveXObject('ShockwaveFlash.ShockwaveFlash'));
    } catch(exception) {
        hasFlash = ('undefined' != typeof navigator.mimeTypes['application/x-shockwave-flash']);
    }

    if(hasFlash) {
        $('.js-flash-button').each(function () {
            let $flashActionButton = $(this);
            let $flashButtonForm = $flashActionButton.parent('.button_to');

            $flashActionButton.show();
            $flashButtonForm.next('.button_to').hide();
        })
    }
});
